<template>
  <div id="app" :data-theme="themeMode">
    <router-view v-wechat-title="  this.$t($route.meta.titleKey)  +' '+ this.$t('h.common.webSuffix')"></router-view>
  </div>
</template>

<script>
import login from './views/account/login.vue'

export default {
  name: 'App',
  components: {
    login
  },
  methods: {},
  mounted() {
    this.$i18n.locale = localStorage.getItem('locale'); // 设置应用的语言为存储的语言设置或默认语言
  },
  computed: {
    themeMode() {
      window.document.documentElement.setAttribute("data-theme", this.$store.state.subject === 'dark' ? 'dark' : 'light');
      return this.$store.state.subject === 'dark' ? 'dark' : 'light';
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/common.scss';
body {
  width: 100%;
  height: 100%;
  @include background_color("pageBackgroundColor");
}

#app{
  font-family: "Open Sans", "system-ui", "Segoe UI", Roboto, Oxygen, Ubuntu, "Fira Sans", "Droid Sans", "Helvetica Neue", sans;
}


.mainBoxForm{
  //表单通用布局
  width: 600px;
  height: 555px;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .12);
  border-radius: 15px;

  text-align: center;
  background-color: #FFFFFF;

  //overflow: scroll;
}

.mainBoxFormHigher{
  //表单通用布局
  width: 600px;
  height: 605px;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .12);
  border-radius: 15px;

  text-align: center;
  background-color: #FFFFFF;

  //overflow: scroll;
}

//@media (max-width: 1300px) {
//  .mainBoxForm {
//    position: absolute;
//    top: 0%;
//    left: 50%;
//    transform: translate(-50%, 0%);
//  }
//}


.cardBoxTitle {
  font-size: 26px;
  margin-top: 10px;
}

.centerBox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 100%;
  height: 100%;
}

.empty-height {
  height: 50px
}

.qidiLogo {
  width: 50px;
  height: 50px;
  margin-top: 50px
}

.goBackButtonBody{
  height: 150px;
}

.pageFooter {
  width: 100%;
  position: absolute;
  bottom: 10px;
  margin: 0 auto;
}

.policiesGoBackButton {
  @include background_color("policiesGoBackButtonBgColor");
  font-size: 28px;
  font-weight: bolder;
  text-align: center;
  margin: 0 auto;
  width: 50%;
  max-width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue